import { Divider, Layout, Typography } from 'antd';
import AppHeader from 'containers/AppLayout/AppHeader';
import React from 'react';
import './Home.scss';
import { t } from 'helpers/i18n';
import ListProduct from './components/ListProduct';
import ListPlatform from './components/ListPlatform';
import ListMarket from './components/ListMarket';
import ListEnvironment from './components/ListEnvironment';
import ListUserRole from './components/ListUserRole';
import ListService from './components/ListService';
import PandoraPlayground from './components/PandoraPlayground/PandoraPlayground';
import ListModule from './components/ListModule';

const Home: React.FC = () => {
  return (
    <Layout className="app-layout">
      <AppHeader>
        <Typography.Title className="home-title">
          {t('TerraDashboard')}
        </Typography.Title>
      </AppHeader>
      <div className="app-header-placeholder" />
      <div className="home-container">
        <ListProduct />
        <ListService />
        {/* TODO: restrict below views to show only to user with admin permission */}
        <ListPlatform />
        <ListMarket />
        <ListEnvironment />
        <ListUserRole />
        <ListModule />

        <Divider />
        <Typography.Title style={{ marginLeft: '16px' }}>
          {t('Tools')}
        </Typography.Title>
        <div className="home-tools-section">
          <PandoraPlayground />
        </div>
      </div>
    </Layout>
  );
};

export default Home;
